import { defineStore } from 'pinia'
import { reactive, ref } from 'vue'

const useModel = defineStore('coords_map', () => {
  const open = ref(false)
  const coords = reactive({
    latitude: 59.9343,
    longitude: 30.3351,
  })

  /**
   * Функция установки значений координат
   * @param latitude
   * @param longitude
   */
  const setValue = (latitude: number, longitude: number) => {
    coords.latitude = latitude
    coords.longitude = longitude
  }

  return {
    open,
    coords,

    setValue,
  }
})

export default useModel
